var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgElectricityCommission(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 10.5719 0 5.85786 2.92893 2.92893C5.85786 0 10.5719 0 20 0H24C33.4281 0 38.1421 0 41.0711 2.92893C44 5.85786 44 10.5719 44 20V24C44 33.4281 44 38.1421 41.0711 41.0711C38.1421 44 33.4281 44 24 44H20C10.5719 44 5.85786 44 2.92893 41.0711C0 38.1421 0 33.4281 0 24V20Z",
    fill: "#00C7BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6328 14.2578L23.625 21.2891H28C28.5078 21.2891 28.9766 21.6016 29.1719 22.0703C29.3281 22.5781 29.2109 23.125 28.8203 23.4766L18.8203 32.2266C18.3516 32.5781 17.7266 32.6172 17.2578 32.2656C16.7891 31.9531 16.5938 31.3281 16.8281 30.7812L19.8359 23.75H15.5C14.9531 23.75 14.4844 23.4375 14.3281 22.9688C14.1328 22.4609 14.25 21.9141 14.6406 21.5625L24.6406 12.8125C25.1094 12.4609 25.7344 12.4219 26.2031 12.7734C26.6719 13.0859 26.8672 13.7109 26.6328 14.2578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgElectricityCommission);
export default __webpack_public_path__ + "static/media/img_electricity_commission.3808b6b6830788b7eb7a4e8c89fdee36.svg";
export { ForwardRef as ReactComponent };